import { render, staticRenderFns } from "./TradeList.vue?vue&type=template&id=0ae699ed&scoped=true&"
import script from "./TradeList.vue?vue&type=script&lang=ts&"
export * from "./TradeList.vue?vue&type=script&lang=ts&"
import style0 from "./TradeList.vue?vue&type=style&index=0&id=0ae699ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae699ed",
  null
  
)

export default component.exports